module.exports = __webpack_public_path__ + "img/work_14.74734d80.png";